/**
 * Utility to map book cover URLs to their specific variants (grid, full, hi, master).
 * Handles both relative API endpoints and external URLs correctly.
 */
export const getCoverUrl = (
    base: string | null | undefined,
    variant: 'grid' | 'full' | 'hi' | 'master',
    bookId?: string
): string => {
    let cleanBase = base || (bookId ? `/api/library/cover/${bookId}` : '');
    if (!cleanBase) return '';

    // Keep external Gutenberg images or other non-library covers untouched
    if (cleanBase.startsWith('http') && !cleanBase.includes('/api/library/cover/')) {
        return cleanBase;
    }

    // Extract base URL without query parameters
    let cleanBaseUrl = cleanBase.split('?')[0];
    if (cleanBaseUrl.endsWith('/')) {
        cleanBaseUrl = cleanBaseUrl.slice(0, -1);
    }

    // Strip any existing variant suffixes or file name variants
    cleanBaseUrl = cleanBaseUrl.replace(/\/cover_(grid|full|hi)\.webp$/, '');
    cleanBaseUrl = cleanBaseUrl.replace(/\/cover_master\.(png|jpg|jpeg)$/, '');
    cleanBaseUrl = cleanBaseUrl.replace(/_(grid|full|hi)$/, '');

    if (variant === 'master') {
        return `${cleanBaseUrl}/cover_master.png`;
    }
    return `${cleanBaseUrl}/cover_${variant}.webp`;
};
